import Component from '../Component';
import Header from './Header';
//import Nav from './Nav';
import Layers from './Layers';
//import Filters from './Filters';
import * as uiStrings from '../../uiStrings';

class ControlPanel extends Component {
	constructor() {
		super();

		this.key = 'control-panel';

		this.header = new Header({
			handleClose: this.close.bind(this),
		});
//		this.nav = new Nav({
//			handleToggleContent: this.handleToggleContent.bind(this),
//		});
		this.layers = new Layers({});
//		this.filters = new Filters({});
	}

	componentDidMount() {
		this.setupEventListeners();

		this.header.setRefs(this.refs);
//		this.nav.setRefs(this.refs);
		this.layers.setRefs(this.refs);
//		this.filters.setRefs(this.refs);

		this.header.componentDidMount();
//		this.nav.componentDidMount();
		this.layers.componentDidMount();
//		this.filters.componentDidMount();

		// TODO
		this.open();
	}

	setupEventListeners() {
		const picker = document.querySelector('.js-load-file-picker');

		picker.addEventListener("change", e => {
			this.dispatchCustomEvent("load-file-click", e.target, true);
		});

		document.querySelector('.js-save-file').addEventListener("click", e => {
			this.dispatchCustomEvent("save-file-click", e.target, true);
		});

		document.querySelector('.js-load-file').addEventListener("click", e => {
			picker.click();
		});

		document.querySelector('.js-export-file').addEventListener("click", e => {
			this.dispatchCustomEvent("export-file-click", e.target, true);
		});
	}

	open() {
		this.component.classList.add('active');
	}

	close() {
		this.component.classList.remove('active');
	}

	handleToggleContent() {
		this.layers.toggleActive();
//		this.filters.toggleActive();
	}

	render() {
		return `
            <div ref="component-${this.key}" class="layerPanel">
                ${this.header.render()}
                <div class="layerPanel__content">
                    ${this.layers.render()}
                </div>
                <div class="layerPanel__footer">
                    <button type="button" class="js-load-file btn btn--link" style="display: none"><i class="fas fa-upload"></i> ${uiStrings.LOAD}</button>
                    <input type="file" class="js-load-file-picker" style="display: none">
                    <button type="button" class="js-save-file btn btn--link" style="display: none"><i class="fas fa-download"></i> ${uiStrings.SAVE}</button>
                    <button type="button" class="js-export-file btn btn--link" style="margin-left: auto; display: none"><i class="fas fa-file-export"></i> ${uiStrings.EXPORT}</button>
                </div>
            </div>`;
	}
}

export default ControlPanel;
